const sitePagesPageType = {
  blogPost: "blogPost",
  staticPage: "staticPage"
};
export {
  sitePagesPageType
};
//# sourceMappingURL=types.js.map
